@let isSecondaryDrawerOpen = dashboardState.secondaryDrawer();

<main class="flex h-[calc(100dvh-64px)] w-dvw overflow-hidden bg-surface-50">
  <main-drawer></main-drawer>
  <div class="m-4 flex grow flex-col">
    <app-custom-breadcrumbs />
    @if (routerState.breadcrumbs().length > 0) {
      <p-breadcrumb
        [model]="routerState.breadcrumbs()"
        styleClass="!pb-0 !pl-4 !pt-0 !bg-surface-50"
        [class]="dashboardState.pageTitle() === '' ? 'mb-4' : ''"
        [injectAttribute]="analyticsForBreadcrumbs()" />
    }

    @if (dashboardState.pageTitle() !== '') {
      <div class="flex items-center py-4 pl-4">
        <back-icon
          (click)="dashboardState.toggleSecondaryDrawer()"
          analytics-label="portfolio/facility/secondary-menu/button/open_close_secondary_drawer"
          [isRotatedFromParent]="isSecondaryDrawerOpen" />
        <h2 class="ml-3">{{ dashboardState.pageTitle() }}</h2>
      </div>
    }

    <div
      class="flex h-full grow overflow-hidden rounded-2xl bg-white shadow-xl
        shadow-surface-200">
      <secondary-drawer />
      <div
        class="h-auto w-1 grow"
        [class]="isSecondaryDrawerOpen ? 'border-l border-surface-200' : ''">
        <div class="fix-size-dashboard contents h-full w-full">
          <router-outlet class="hidden"></router-outlet>
        </div>
      </div>
    </div>
  </div>
</main>
